import React from "react"
import { Box, Typography } from "@mui/material"
import BrandingService from "../branding/BrandingService"

export default function Footer() {
  return (
    <Box bgcolor="lightgrey" padding={1}>
      <Typography variant="h6" align="center">
        Powered By {BrandingService.current.name}
      </Typography>
    </Box>
  )
}